import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServiceCallUtilsService } from '../service-call-utils.service';
import { constants } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class FooterService {

  constructor(private http: HttpClient, private serviceCallUtilsService: ServiceCallUtilsService) { }
  /**
  * Description: Método que llama el servicio web que obtiene los otros documentos
  * Autor: Fernando Herdoiza
  * @return Listado los otros documentos
  */
  getOtherDocuments() {
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_OTHER_DOCUMENTS, {});
  }
}
